import { config } from '@fortawesome/fontawesome-svg-core';

config.autoAddCss = false;